import { observable } from '@nx-js/observer-util';

const WP = observable({});

export default WP;
